import Immutable, { Map } from 'immutable';
import { createStore, getActionIds } from '../helpers/redux';
import { ProjectActions } from '../actions/project';
//import { RelationshipActions } from '../actions/relationship';
import { RelationshipTypeActions } from '../actions/relationshipType';
import { RelationshipActions } from '../actions/relationship';
import { ViewActions } from '../actions/view';
// import { TagActions } from '../actions/tag';

const projectActions = getActionIds(ProjectActions);
const relationshipActions = getActionIds(RelationshipActions);
const relationshipTypeActions = getActionIds(RelationshipTypeActions);
const viewActions = getActionIds(ViewActions);
// const tagActions = getActionIds(TagActions);

const initialState = Immutable.fromJS({
  relationshipTypes: {},
  loading: {
    types: [],
    //tags: [],
    comments: []
  },
  loaded: {
    all: false,
    types: [],
    //tags: [],
    comments: []
  },
  meta: {
    sortType: null
  }
});

export const relationshipTypes = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.setIcon.success]: (state, action) => {
    const componentType = action.result.result.componentType;

    if(componentType !== "relationshipTypes") return state;

    return state.mergeDeep({
      relationshipTypes: {
        [action.result.result.componentId]: {
          icon_id: action.result.result.iconId
        }
      }
    })
  },
  // "types" should be renamed to relationshipTypes so we don't run into conflicts with other things keyed as "types"

  // ['*']: (state, action) => {
  //   if (action.result && action.result.entities && action.result.entities. action.result.entities.types) {
  //     return state.mergeDeep({
  //       relationshipTypes: action.result.entities.types
  //     });
  //   }

  //   return state;
  // },

  // [RelationshipTypeActions.getProjectRelationshipTypes.begin]: (state, action) => {
  //   const relationshipTypeIds = state.getIn(['loading', 'types']);
  //   return state.setIn(['loading', 'comments'], commentIds.push(action.args[0]));
  // },

  // [commentActions.getElementComments.success]: (state, action) => {
  //   const commentIds = state.getIn(['loaded', 'comments']);
  //   const loadingIndex = state.getIn(['loading', 'comments']).findIndex(function(index){ return index == action.result.id});
  //   let loadingIds = state.getIn(['loading', 'comments']);
  //   loadingIds = loadingIds.delete(loadingIndex);
  //   return state.setIn(['loaded', 'comments'], commentIds.push(action.result.id)).setIn(['loading', 'comments'], loadingIds);
  // },

  [projectActions.sortData]: (state, action) => {
    const sortOn = action.sortOn;

    if(sortOn !== "relTypes") return state;

    const sortType = action.sortType;

    let relationshipTypes = state.get('relationshipTypes').sort((a,b) => {
      let lowerCaseA = a.get('type').toLowerCase();
      let lowerCaseB = b.get('type').toLowerCase();

      switch(sortType){
        case "ascending":
          if(lowerCaseA < lowerCaseB){
            return -1;
          } else if (lowerCaseA > lowerCaseB){
            return 1;
          } else {
            return 0
          }
        case "descending":
          if(lowerCaseA < lowerCaseB){
            return 1;
          } else if (lowerCaseA > lowerCaseB){
            return -1;
          } else {
            return 0
          }
        case "date":
          if(a.get('created_at') > b.get('created_at')){
            return -1;
          } else if (a.get('created_at') < b.get('created_at')){
            return 1;
          } else {
            return 0
          }
        default:
          return 0;
      }
    })

    return state.merge({
      relationshipTypes: relationshipTypes,
      meta: {
        sortType: sortType
      }
    })
  },

  [relationshipActions.getRelationships.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: action.result.entities.types
    });
  },

  [relationshipActions.getRelationship.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: action.result.entities.types
    });
  },

  // [tagActions.getObjectsByTags.success]: (state, action) => {
  //   if (action.args[2] !== 'Relationship' || !action.result.entities.types) return state;
  //
  //   return state.mergeDeep({
  //     relationshipTypes: action.result.entities.types
  //   });
  // },

  [viewActions.getView.success]: (state, action) => {
    if(!action.result.entities.types) return state;
    return state.mergeDeep({
      relationshipTypes: action.result.entities.types
    })
  },

  [relationshipTypeActions.deleteRelationshipTypeMetaProperty.success]: (state, action) => {
    return state.deleteIn(['relationshipTypes', action.result.relationshiptype_id.toString(), 'props', action.result.prop, action.result.meta_key]);
  },

  [relationshipTypeActions.updateRelationshipTypeMetaValue.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.id]: {
          props: Immutable.fromJS(action.result.props)
        }
      }
    });
  },

  [relationshipTypeActions.saveRelationshipTypeProperty.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.id]: {
          props: action.result.props
        }
      }
    });
  },

  [relationshipTypeActions.renameRelationshipType.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.result]: {
          type: action.result.entities.relationshipTypes[action.result.result].type
        }
      }
    });
  },

  [relationshipTypeActions.renameRelationshipTypeProperty.success]: (state, action) => {
    return state;

  },

  [relationshipTypeActions.createRelationshipTypeProperty.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.id]: {
          props: action.result.props
        }
      }
    });
  },

  [relationshipTypeActions.deleteRelationshipType.success]: (state, action) => {
    return state.deleteIn(['relationshipTypes', action.result.relationshipTypeId.toString()]);
  },

  [relationshipTypeActions.deleteRelationshipTypeProperty.success]: (state, action) => {
    return state.deleteIn(['relationshipTypes', action.result.relationshiptype_id.toString(), 'props', action.result.deleted_key]);
  },

  [relationshipTypeActions.createRelationshipType.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.result]: action.result.entities.relationshipTypes[action.result.result]
      }
    });
  },

  [relationshipTypeActions.getProjectRelationshipTypes.begin]: (state, action) => {
    const relationshipTypeIds = state.getIn(['loading', 'types']);
    return state.setIn(['loading', 'types'], relationshipTypeIds.push(action.args[0])).setIn(['loading', 'all'], true);
  },

  // [commentActions.getElementComments.success]: (state, action) => {
  //   const commentIds = state.getIn(['loaded', 'comments']);
  //   const loadingIndex = state.getIn(['loading', 'comments']).findIndex(function(index){ return index == action.result.id});
  //   let loadingIds = state.getIn(['loading', 'comments']);
  //   loadingIds = loadingIds.delete(loadingIndex);
  //   return state.setIn(['loaded', 'comments'], commentIds.push(action.result.id)).setIn(['loading', 'comments'], loadingIds);
  // },

  [relationshipTypeActions.getProjectRelationshipTypes.success]: (state, action) => {
    if(!action.result.entities.relationshipTypes) return state;
    return state.mergeDeep({
      relationshipTypes: action.result.entities.relationshipTypes,
      loading: { all: true },
      loaded: { all: true }
    });
  },

  [relationshipTypeActions.getRelationshipType.begin]: (state, action) => {
    const relationshipTypeIds = state.getIn(['loading', 'types']);
    //debugger;
    return state.setIn(['loading', 'types'], relationshipTypeIds.push(action.args[0]));
  },

  [relationshipTypeActions.getRelationshipType.success]: (state, action) => {
    if(!action.result.entities.relationshipTypes) return state;
    return state.mergeDeep({
      relationshipTypes: action.result.entities.relationshipTypes,
      loading: { types: state.deleteIn(['loading', 'types', action.args[0]]) },
      loaded: { types: state.getIn(['loaded', 'types']).push(action.args[0]) }
    });
  },

  [relationshipTypeActions.getRelationshipType.failure]: (state, action) => {
    // const relationshipTypeIds = state.getIn(['loading', 'types']);
    return state.mergeDeep({
      loading: { types: state.deleteIn(['loading', 'types', action.args[0]]) },
      loaded: { types: state.getIn(['loaded', 'types']).push(action.args[0]) }
    });
  },

  [relationshipTypeActions.createRelationshipTypeMetaProperty.success]: (state, action) => {
    const relationshipTypeId = action.result.relationshiptype_id.toString();
    // const currentRelationshipTypeProps = state.getIn(['relationshipTypes', relationshipTypeId, 'props']);
    // const oldPropData = currentRelationshipTypeProps.get(action.result.deleted_key);
    // let updatedRelationshipTypeProps = currentRelationshipTypeProps.delete(action.result.deleted_key);
    // updatedRelationshipTypeProps = updatedRelationshipTypeProps.set(action.result.new_key, oldPropData);
    //const oldPropData = state.get('')
    return state.setIn(['relationshipTypes', relationshipTypeId, 'props', action.result.prop, action.result.meta_key], Immutable.fromJS(action.result.meta_value));
  },


  [relationshipTypeActions.renameRelationshipTypeProperty.success]: (state, action) => {
    const relationshipTypeId = action.result.relationshiptype_id.toString();
    const currentRelationshipTypeProps = state.getIn(['relationshipTypes', relationshipTypeId, 'props']);
    const oldPropData = currentRelationshipTypeProps.get(action.result.deleted_key);
    let updatedRelationshipTypeProps = currentRelationshipTypeProps.delete(action.result.deleted_key);
    updatedRelationshipTypeProps = updatedRelationshipTypeProps.set(action.result.new_key, oldPropData);
    //const oldPropData = state.get('')
    return state.setIn(['relationshipTypes', relationshipTypeId, 'props'], updatedRelationshipTypeProps);
  },

  [relationshipTypeActions.renameRelationshipTypeMetaProperty.success]: (state, action) => {
    const relationshipTypeId = action.result.relationshiptype_id.toString();
    const currentRelationshipTypeMetaProps = state.getIn(['relationshipTypes', relationshipTypeId, 'props', action.result.prop]);
    const oldMetaData = currentRelationshipTypeMetaProps.get(action.result.deleted_meta_key);
    let updatedRelationshipTypeMetaProps = currentRelationshipTypeMetaProps.delete(action.result.deleted_meta_key);
    updatedRelationshipTypeMetaProps = updatedRelationshipTypeMetaProps.set(action.result.new_meta_key, oldMetaData);
    return state.setIn(['relationshipTypes', relationshipTypeId, 'props', action.result.prop], updatedRelationshipTypeMetaProps);
  },

  [relationshipTypeActions.saveDescription.success]: (state, action) => {
    return state.mergeDeep({
      relationshipTypes: {
        [action.result.result]: {
          description: action.result.entities.relationshipTypes[action.result.result].description
        }
      }
    });
  },

  [relationshipTypeActions.updatePropsOrder]: (state, action) => {
    const relationshipTypeId = action.relationshipTypeId;
    const hoverKey = action.hoverKey;
    const dragKey = action.dragKey;
    const hoverOrder = state.getIn(['relationshipTypes', relationshipTypeId, 'props', hoverKey, '_order']);
    const dragOrder = state.getIn(['relationshipTypes', relationshipTypeId, 'props', dragKey, '_order']);

    const newProps = state.getIn(['relationshipTypes', relationshipTypeId, 'props']).map((prop, key) => {
      const propOrder = prop.get('_order');

      if (key === dragKey) {
        return prop.set('_order', hoverOrder);
      }

      if (propOrder <= hoverOrder && propOrder >= dragOrder) {
        return prop.set('_order', propOrder - 1);
      }

      if (propOrder >= hoverOrder && propOrder <= dragOrder) {
        return prop.set('_order', propOrder + 1);
      }

      return prop;
    });

    return state.mergeDeep({
      relationshipTypes: {
        [relationshipTypeId]: {
          props: newProps
        }
      }
    });
  },

  // [relationshipActions.getRelationship.success]: (state, action) => {
  //   if(!action.result.entities.types) return state;
  //   return state.mergeDeep({
  //     relationshipTypes: action.result.entities.types
  //   });
  // },

  // [relationshipActions.getRelationship.success]: (state, action) => {
  //   if(!action.result.entities.types) return state;
  //   return state.mergeDeep({
  //     relationshipTypes: action.result.entities.types
  //   });
  // },
});

export const currentRelationshipTypeIdSelector = (state, props) => {
  return props.currentRelationshipTypeId || (
    (props.routeParams) ?
      props.routeParams.relationshipTypeId :
      null
    );
};

export const currentRelationshipTypeSelector = (state, props) => {
  const currentRelationshipTypeId = currentRelationshipTypeIdSelector(state, props);

  return state.relationshipTypes.getIn(['relationshipTypes', currentRelationshipTypeId], Map());
};

export const dependencyTypeIdSelector = (state) => {
  const dependencyType = state.relationshipTypes
    .get('relationshipTypes').find((a) => a.get('type') === 'Dependency');

  return dependencyType ? dependencyType.get('id') : null;
};

export const issueRelationshipTypeIdSelector = (state) => {
  const dependencyType = state.relationshipTypes
    .get('relationshipTypes').find((a) => a.get('type') === 'Issue');

  return dependencyType ? dependencyType.get('id') : null;
}

export const companyRelationshipTypeIdSelector = (state) => {
  const dependencyType = state.relationshipTypes
    .get('relationshipTypes').find((a) => a.get('type') === 'Company');

  return dependencyType ? dependencyType.get('id') : null;
}

export const wbsRelTypeIdSelector = (state) => {
  const wbsType = state.relationshipTypes
    .get('relationshipTypes').find((a) => a.get('type') === 'Work Breakdown Structure');

  return wbsType ? wbsType.get('id') : null;
};

export const shouldLoadRelationshipTypesSelector = (state) =>
  !state.relationshipTypes.getIn(['loading', 'all']) && !state.relationshipTypes.getIn(['loaded', 'all']);


export const relationshipTypesSelector = (state, props) =>
  state.relationshipTypes.get('relationshipTypes', Map());

export const sortSelector = (state) =>
  state.relationshipTypes.getIn(['meta', 'sortType']);



// WEBPACK FOOTER //
// ./src/reducers/relationshipTypes.js